export enum PageTitles {
  PROFILE = "Профиль",
  COURT_RENT = "Аренда кортов",
  RACKET_RENT = "Аренда ракеток",
  SERVICES = "Сервис",
  CART = "Корзина",
  PAYMENT = "Оплата",
  CONTACTS = "Контакты",
  SCHOOL = "Школа тенниса",
  PERSONAL_TRAINING = "Персональные тренировки",
  PRODUCTS = "Товары",
  STORAGE = "Хранение спортивного инвентаря",
  ABOUT = "О клубе",
  RULES = "Правила Клуба",
  POLITICS = "Политика конфиденциальности",
  NOT_FOUND = "Страница не найдена",
  // need to add all
}

export const ValidMessages = {
  inputs: {
    name: {
      REQUIRED: 'Поле "ФИО" обязательно для заполнения',
    },
		child_birthday:{
			REQUIRED:'Поле "Дата рождения" обязательно для заполнения'
		},
    email: {
      REQUIRED: 'Поле "Email" обязательно для заполнения',
      INCORRECT: "Неправильный формат электронной почты",
    },
    pinCode: {
      REQUIRED: "Пожалуйста, введите пин-код, который был отправлен на вашу почту",
      NOT_FULL: "Пин-код состоит из 4 цифр",
      INCORRECT: "Вы ввели неправильный пин-код",
    },
    emailChange: {
      REQUIRED: "Пожалуйста, введите код, который был отправлен на вашу почту",
      NOT_FULL: "Код состоит из 4 цифр",
      INCORRECT: "Вы ввели неправильный код",
    },
    phone: {
      REQUIRED: 'Поле "телефон" обязательно для заполнения',
      NOT_FULL: 'Количество символов в поле "телефон" должно быть не менее 11',
    },
    password: {
      REQUIRED: 'Поле "Введите новый пароль" обязательно для заполнения',
      NOT_FULL: 'Количество символов в поле "пароль" должно быть не менее 6',
    },
    passwordRepeat: {
      REQUIRED: 'Поле "Повторите пароль" обязательно для заполнения',
      NOT_MATCH: "Пароли должны совпадать",
    },
    acceptPersonalData: {
      REQUIRED: "Необходимо подтвердить, что Вы ознакомлены и согласны с условиями обработки персональных данных",
    },
    acceptTerms: {
      REQUIRED:
        "Необходимо подтвердить, что Вы ознакомлены и согласны с условиями оплаты",
    },
    acceptOffer: {
      REQUIRED:
        "Необходимо подтвердить, что Вы ознакомлены и согласны с условиями оферты и правилами клуба",
    },
    acceptGrunt: {
      REQUIRED:
        "Необходимо подтвердить, что Вы ознакомлены с правилами переброни грунта",
    },
    message: {
      NOT_FULL: 'Количество символов в поле "ваше сообщение" должно быть не менее 10',
      REQUIRED: "Необходимо ввести сообщение",
    },
    child_name: {
      REQUIRED: 'Поле "ФИО" обязательно для заполнения',
    },
    parent_name: {
      REQUIRED: 'Поле "ФИО родителя" обязательно для заполнения',
    },
    level: {
      REQUIRED: "Необходимо выбрать уровень",
    },
  },
};

export const ModalTexts = {
  common: {
    error: {
      TITLE: "Ошибка!",
      SUB_TITLE: "Что-то пошло не так. Попробуйте позже или свяжитесь с нами",
    },
  },
  changePass: {
    inputPhone: {
      recovery: {
        TITLE: "Введите номер",
        SUB_TITLE: "На указанный номер телефона будет отправлено письмо с кодом подтверждения",
      },
      change: {
        TITLE: "Смена пароля",
        SUB_TITLE: "Введите номер телефона",
      },
    },
    confirmMessage: {
      TITLE: "Введите код из SMS",
      SUB_TITLE: null,
    },
    inputSmsCode: {
      TITLE: "Введите код из SMS",
      SUB_TITLE: null,
    },
    inputNewPassword: {
      TITLE: "Задайте новый пароль",
      SUB_TITLE: null,
    },
    passwordApply: {
      TITLE: "Пароль обновлен",
      SUB_TITLE: "Ваш пароль успешно обновлен",
    },
    errorPhone: {
      TITLE: "Такой телефон не найден",
      SUB_TITLE: "Убедитесь, что правильно ввели номер или свяжитесь с нами",
    },
    errorCode: {
      TITLE: "Неправильный код",
      SUB_TITLE: "Убедитесь, что правильно ввели пин-код из смс",
    },
  },
  courtRent: {
    errorNoSelectedSeats: {
      TITLE: "Выберите корт и время",
      SUB_TITLE: "Для бронирования необходимо выбрать в таблице корт и время",
    },
    errorUnAvailable: {
      TITLE: "Выбранный корт уже заняли",
      SUB_TITLE:
        "Упс! Видимо кто-то уже положил к себе в корзину выбранный Вами корт. Выберите другой корт или время",
    },
  },
  racketRent: {
    errorNoSelectedRackets: {
      TITLE: "Выбрать время",
      SUB_TITLE: "Для бронирования ракеток необходимо выбрать время в таблице",
    },
    errorUnAvailable: {
      TITLE: "Не достаточно ракеток",
      SUB_TITLE: "На выбранное Вами время не достаточно свободных ракеток",
    },
  },
  appInfo: {
    TITLE: "Предупреждение",
    SUB_TITLE: "На сервере ведутся технические работы, просьба подождать",
  },
  auth: {
    authStart: {
      TITLE: "Авторизация",
      SUB_TITLE: null,
    },
    authSuccess: {
      TITLE: "Вход выполнен",
      SUB_TITLE: "Вы успешно авторизировались на сайте",
    },
    authError: {
      TITLE: "Произошла ошибка",
      SUB_TITLE:
        "Убедитесь, что правильно ввели данные для авторизации или воспользуйтесь средством восстановления пароля",
    },
  },
  register: {
    regStart: {
      TITLE: "Регистрация",
      SUB_TITLE: null,
    },
    regSuccess: {
      TITLE: "Вы зарегистрировались",
      SUB_TITLE:
        "Вы успешно зарегистрировались и автоматически авторизировались на сайте",
    },
  },
  addCard: {
    confirmation: {
      TITLE: "Удалить карту?",
      SUB_TITLE: "Вы уверены, что хотите удалить данную карту?",
    },
  },
  payment: {
    afk: {
      TITLE: "Внимание!",
      SUB_TITLE: "Вы слишком долго находитесь в режиме оплаты",
    },
  },
  services: {
    successModal: {
      TITLE: "Заявка отправлена!",
      SUB_TITLE: "Наш менеджер скоро с Вами свяжется",
    },
  },
  feedback: {
    TITLE: "Оставьте свой вопрос и мы свяжемся с Вами с ответом!",
  },
  feedbackSuccess: {
    TITLE: "Сообщение отправлено!",
    SUB_TITLE:
      "Наши менеджеры скоро ответят Вам",
  },
};

export const dayNamesForRent = [
  "Вс",
  "Пн",
  "Вт",
  "Ср",
  "Чт",
  "Пт",
  "Сб",
  "Воскресенье",
  "Понедельник",
  "Вторник",
  "Среда",
  "Четверг",
  "Пятница",
  "Суббота",
];

export const monthNamesForCalendar = [
  "Янв",
  "Фев",
  "Март",
  "Апр",
  "Май",
  "Июнь",
  "Июль",
  "Авг",
  "Сент",
  "Окт",
  "Нояб",
  "Дек",
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

export const siteUrl = {
  yandexMap: {
    MAP_YANDEX_MOBILE:
      "https://static-maps.yandex.ru/1.x/?l=map&lang=ru_RU&ll=37.41093430370709%2C55.570802104604034&origin=jsapi-constructor&pt=37.410309%2C55.570065%2Cpm2bll&size=328%2C240&z=14",
    MAP_YANDEX_BP:
      "https://static-maps.yandex.ru/1.x/?l=map&lang=ru_RU&ll=37.41093430370709%2C55.570802104604034&origin=jsapi-constructor&pt=37.410309%2C55.570065%2Cpm2bll&size=484%2C240&z=14",
    MAP_YANDEX:
      "https://static-maps.yandex.ru/1.x/?l=map&lang=ru_RU&ll=37.41093430370709%2C55.570802104604034&origin=jsapi-constructor&pt=37.410309%2C55.570065%2Cpm2bll&size=533%2C360&z=14",
  },
  google_direction: {
    MAP_DESTINATION:
      "https://www.google.com/maps/dir//Tennis.ru,+%D1%83%D0%BB.+%D0%9B%D0%B5%D1%82%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F+%D0%9C%D0%B0%D0%BB%D0%B0%D1%8F,+8,+%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0,+%D0%9C%D0%BE%D1%81%D0%BA%D0%BE%D0%B2%D1%81%D0%BA%D0%B0%D1%8F+%D0%BE%D0%B1%D0%BB.,+142791/@55.5696399,37.3880903,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x46b5534fc481e599:0x2e4bc23e56d8e0c4!2m2!1d37.410379!2d55.570109",
  },
};

export const about_direction = {
  titles: {
    ADDRESS: "г. Москва, ул. Летовская Малая, 8",
    METRO: "Ольховая",
    BUS: "878, до остановки «Ларево»",
  },
};
